import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitItinerary = (data) => api.post("/itinerary", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitBooking = (data) => api.post("/booking", data).then((r) => r.data);
